(function () {
  function initDiscountPopup() {
    const params = new URLSearchParams(window.location.search);

    if (params.get('discount_popup') !== 'hello50') {
      return;
    }

    // Create popup
    const popup = document.createElement('div');

    popup.className = 'discount-success-popup';

    popup.innerHTML = `
      <div class="discount-success-popup__overlay"></div>

      <div class="discount-success-popup__content">
        <button
          type="button"
          class="discount-success-popup__close"
          aria-label="Close"
        >
          ×
        </button>

        <img
          class="discount-success-popup__icon"
          src="//minicat.shop/cdn/shop/t/1/assets/happy-minicat.png?v=101570011949816541751786351485"
          alt="Happy Minicat"
        >

        <h2 class="discount-success-popup__title">
          Your discount code has been added!
        </h2>

        <p class="discount-success-popup__text">
          Your 50% discount is ready and will be applied at checkout.
        </p>
      </div>
    `;

    document.body.appendChild(popup);

    // Add styles
    const style = document.createElement('style');

    style.textContent = `
      .discount-success-popup {
        position: fixed;
        inset: 0;
        z-index: 999999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
      }

      .discount-success-popup__overlay {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
      }

      .discount-success-popup__content {
        position: relative;
        z-index: 1;
        width: 100%;
        max-width: 440px;
        padding: 40px 30px;
        box-sizing: border-box;
        background: #fff;
        border-radius: 12px;
        text-align: center;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
      }

      .discount-success-popup__close {
        position: absolute;
        top: 10px;
        right: 14px;
        width: 32px;
        height: 32px;
        padding: 0;
        border: 0;
        background: transparent;
        font-size: 28px;
        line-height: 32px;
        cursor: pointer;
      }

      .discount-success-popup__icon {
  display: block;
  width: 100px;
  height: 100px;
  margin: 0 auto 20px;
  object-fit: contain;
}

      .discount-success-popup__title {
        margin: 0 0 12px;
        font-size: 24px;
        line-height: 1.2;
      }

      .discount-success-popup__text {
        margin: 0;
        font-size: 16px;
        line-height: 1.5;
      }

      @media screen and (max-width: 749px) {
        .discount-success-popup__content {
          max-width: calc(100% - 20px);
          padding: 35px 20px 25px;
        }

        .discount-success-popup__title {
          font-size: 21px;
        }
      }
    `;

    document.head.appendChild(style);

    // Close popup
    const closeButton = popup.querySelector(
      '.discount-success-popup__close'
    );

    const overlay = popup.querySelector(
      '.discount-success-popup__overlay'
    );

    function closePopup() {
      popup.remove();
      style.remove();
    }

    closeButton.addEventListener('click', closePopup);
    overlay.addEventListener('click', closePopup);

    // Remove discount_popup from URL
    params.delete('discount_popup');

    const queryString = params.toString();

    const cleanUrl =
      window.location.pathname +
      (queryString ? '?' + queryString : '') +
      window.location.hash;

    window.history.replaceState(
      {},
      document.title,
      cleanUrl
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initDiscountPopup
    );
  } else {
    initDiscountPopup();
  }
})();